export default __webpack_public_path__ + "img/b9c3ceb501fc61a23caf32492e39f9a8.svg";